// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-application.chat-app .title{font-weight:unset;line-height:unset;font-family:sans-serif!important;letter-spacing:normal!important}.v-application.chat-app p{margin-bottom:unset}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
